<div class="header">
    <ng-container *ngIf="!showListArticles">
        <button class="btn btn-back" (click)="goBack()">Go back to List </button>
    </ng-container>
    <button class="btn btn-insert" (click)="newArticle()">New Article</button>
</div>

<ng-container *ngIf="showListArticles">
<div class="content-articles">
    <div class="mat-elevation-z8">
        <table mat-table [dataSource]="dataSource">
      
          <!-- Id Column -->
            <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef> Id. </th>
                <td mat-cell *matCellDef="let element"> {{element.id}} </td>
            </ng-container>
        
            <!-- Title Column -->
            <ng-container matColumnDef="title">
                <th mat-header-cell *matHeaderCellDef> Title </th>
                <td mat-cell *matCellDef="let element"> {{element.title}} </td>
            </ng-container>

            <!-- Id Article -->
            <ng-container matColumnDef="article_id">
                <th mat-header-cell *matHeaderCellDef> Article Id </th>
                <td mat-cell *matCellDef="let element"> {{element.article_id}} </td>
            </ng-container>
        
            <!-- Image Column -->
            <ng-container matColumnDef="image">
                <th mat-header-cell *matHeaderCellDef> Image </th>
                <td mat-cell *matCellDef="let element"> {{element.image}} </td>
            </ng-container>

            <!-- Tags Column -->
            <ng-container matColumnDef="environment">
                <th mat-header-cell *matHeaderCellDef> Environment </th>
                <td mat-cell *matCellDef="let element"> {{element.environment}} </td>
            </ng-container>

            <!-- Tags Column -->
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef> Category </th>
                <td mat-cell *matCellDef="let element"> {{element.category}} </td>
            </ng-container>

            <!-- Tags Column -->
            <ng-container matColumnDef="tags">
                <th mat-header-cell *matHeaderCellDef> Tags </th>
                <td mat-cell *matCellDef="let element"> {{element.tags}} </td>
            </ng-container>

            <!-- Date Create Column -->
            <ng-container matColumnDef="creationDate">
                <th mat-header-cell *matHeaderCellDef> Creation </th>
                <td mat-cell *matCellDef="let element"> {{element.creationDate}} </td>
            </ng-container>

            <!-- Date Update Column -->
            <ng-container matColumnDef="updateDate">
                <th mat-header-cell *matHeaderCellDef> Update </th>
                <td mat-cell *matCellDef="let element"> {{element.updateDate}} </td>
            </ng-container>

      
          <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="{'selected': selectedRowIndex == row.id}" (click)="addArticle(row)"></tr><!--(click)="selection.toggle(row)"-->
        </table>
      
        <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>
      </div>
</div>
</ng-container>

<ng-container *ngIf="showEditor">
    <div class="editor-rich">
        <div class="box-selection">
            <div class="select-environment">
                <mat-form-field appearance="fill">
                    <mat-label>Environment</mat-label>
                    <mat-select [(value)]="selectedEnvironment" (selectionChange)="changeEnv($event.value)" required>
                      <mat-option value="front-end">front-end</mat-option>
                      <mat-option value="back-end">back-end</mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            <div class="select-category">
                <mat-form-field appearance="fill">
                    <mat-label>Category</mat-label>
                    <mat-select [(value)]="selectedCategory" (selectionChange)="changeCategory($event.value)" required>
                      <mat-option *ngFor="let category of categories" [value]="category.value">
                          {{category.value}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
            </div>
            <div class="tags">
                <mat-form-field appearance="fill">
                    <mat-label>Favorite tags</mat-label>
                    <input matInput placeholder="Ex. angular" value="" [(ngModel)]="htmlTags">
                </mat-form-field>
            </div>
        </div>

        <div class="content-title">
            <label>Title:</label>
            <input type="text" id="title" name="title" [(ngModel)]="htmlTitle">
        </div>
        <angular-editor [placeholder]="'Enter text here...'" [(ngModel)]="htmlContent" [config]="config"></angular-editor>
        <h5 class="html-header">HTML Output</h5>
        <div class="html-output">
          {{ htmlContent }}
        </div>
        
        <div class="content-button">
            <ng-container *ngIf="!showListArticles; else editArticle">
                <button type="button" class="btn btn-publish" (click)="postArticle()">Publish</button>
            </ng-container>
            <ng-template #editArticle>
                <button type="button" class="btn btn-publish" (click)="updateArticle()">Update</button>
                <button type="button" class="btn btn-delete" (click)="deleteArticle()">Delete</button>
            </ng-template>
        </div>
    </div>
</ng-container>
